import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { selectMeState } from '@app/core/store/core.selectors';
import { deleteScopeMode, DeleteScopeMode } from './delete-scope';

@Component({
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements AfterViewInit{
  public form: FormGroup = new FormGroup({
    delete: new FormControl(),
    reason: new FormControl()
  });
  public disabled: boolean = true;
  // Admin-only product-delete scope choice (opt-in via data.deleteScopeChoice).
  public isAdmin: boolean = false;
  // Admins of a single-location account skip the choice and delete account-wide.
  public scopeMode: DeleteScopeMode = 'single';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private store$: Store,
  ) {
    this.store$.select(selectMeState).pipe(first()).subscribe((me: any) => {
      this.isAdmin = me?.usrIsPrivileged == 1;
      this.scopeMode = deleteScopeMode(!!this.data?.deleteScopeChoice, this.isAdmin, me?.usrLocations);
    });
  }

  ngAfterViewInit(): void {
    document.getElementById('ConfirmModal__input').focus();
  }

  onCheckInputEvent(event) {
    if (event.target.value.toLowerCase() == this.data.deletePassword.toLowerCase()) this.disabled = false;
    else return this.disabled = true;
    if(event.keyCode == 13 && this.canConfirm){
      document.getElementById('ConfirmModal__submitButton')?.click();
    }

  }

  // data.reasonRequired makes the reason field mandatory; callers that only
  // pass data.reason keep it optional.
  get canConfirm(): boolean {
    if (this.disabled) { return false; }
    if (this.data.reason && this.data.reasonRequired) {
      return (this.form.get('reason')?.value || '').toString().trim() !== '';
    }
    return true;
  }

}
